const reportData = {
    "items":[
        {
            id: '1',
            url: '/reports/dashboardStaticCount/v1/',
            display_text : "Fast Moving SKUs last 15 days",
            report_type: "FastMovingSKUS",
            data_count:0,
			on_click:'/fastmovinglastdetail',
			data_unit:'',
			show: true,
            category : "dynamic"
        },{
            id: '2',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Slow Moving SKUs last 15 days",
            report_type: "SlowMovingSKUS",
            data_count:0,
			on_click:'/slowmovinglastdetail',
			data_unit:'',
			show: true,
            category : "dynamic"
        },{
            id: '3',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Bin Consolidation Candidates",
            report_type: "BinConsolidation",
            data_count:0,
			on_click:'/binconsolidationcandidatesdetail',
			data_unit:'',
			show: true,
            category : "dynamic"
        },{
            id: '4',
            url : '/reports/dashboardStaticCount/v1/',
            display_text : "Stock nearing expiry X Months",
            report_type: "ShelfLife",
            data_count:0,
			on_click:'/shelflifedetail',
			data_unit:'',
			show: true,
            category : "dynamic"
        }   
    ]
}

export default reportData;